// extracted by mini-css-extract-plugin
export var addWidgetButton = "_z-6";
export var backButton = "_z-1";
export var legacyWidgetContainer = "_z-5";
export var pageContainer = "_z-2";
export var settingsContent = "_z-0";
export var widgetSubsectionItem = "_z-3";
export var widgetSubsectionItemContent = "_z-4";